export interface IDocumentType {
  id: number,
  name: string,
  description: string,
  status: boolean
}

export enum EDocumentType {
  rut = 1,
  passport = 2
}